"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.install = exports.setTransport = void 0;

// 设置上报
var transport = function transport() {};

var setTransport = function setTransport(fn) {
  return transport = fn;
};

exports.setTransport = setTransport;

var install = function install(_ref) {
  var browserInfo = _ref.browserInfo,
      useFrequency = _ref.useFrequency,
      pageTime = _ref.pageTime,
      pageCrash = _ref.pageCrash,
      pageStuck = _ref.pageStuck,
      timeoutHttp = _ref.timeoutHttp;

  var getPageTime = function getPageTime() {
    return null;
  };

  var getBrowserInfo = function getBrowserInfo() {
    return null;
  };

  var getUseFrequency = function getUseFrequency() {
    return null;
  };

  var destoryUseFrequency = function destoryUseFrequency() {
    return null;
  };

  var destoryPageCrash = function destoryPageCrash() {};

  if (browserInfo) {
    import('./browserInfo').then(function (_ref2) {
      var get = _ref2.default;
      return getBrowserInfo = get;
    });
  }

  if (useFrequency) {
    import('./useFrequency').then(function (_ref3) {
      var get = _ref3.default,
          destory = _ref3.destory;
      getUseFrequency = get;
      destoryUseFrequency = destory;
    });
  }

  if (pageTime) {
    import('./pageTime').then(function (_ref4) {
      var get = _ref4.default;
      return getPageTime = get;
    });
  }

  if (timeoutHttp) {
    import('./timeoutHttp').then(function (_ref5) {
      var start = _ref5.default;
      return start();
    });
  }

  if (pageCrash) {
    import('./pageCrash').then(function (_ref6) {
      var start = _ref6.start,
          destory = _ref6.destory;
      start();
      destoryPageCrash = destory;
    });
  }

  if (pageStuck) {
    import('./pageStuck').then(function (_ref7) {
      var start = _ref7.default;
      return start();
    });
  }

  window.addEventListener('load', function () {
    transport({
      data: [getPageTime(), getBrowserInfo(), getUseFrequency()]
    });
  });
  window.addEventListener('beforeunload', function () {
    destoryPageCrash();
    destoryUseFrequency();
  });
};

exports.install = install;